import type { Media } from "../types/media";

export function isVideoMedia(media: Media | undefined | null): boolean {
  if (!media) {
    return false;
  }
  return (
    media.contentType?.toLowerCase().startsWith("video/") ||
    !!media.playbackUrl ||
    /\.(mp4|mov|m4v|webm)$/i.test(media.filename || "")
  );
}
